<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "app",
    data() {
      return {};
    },
    watch: {},
    created() {
    },
    methods: {},
    computed: {}
  };
</script>
<style lang="scss">
  #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// App.vue?27ea56d6